import { relatedStoriesType } from '@lib/proptypes';
import Carousel from '@molecules/Carousel/Carousel';
import PagepartBase from '@molecules/PagepartBase/PagepartBase';
import StoryItem from '@molecules/StoryItem/StoryItem';
import { useRelatedStories } from '@utils';

function RelatedStoriesSection({ id, title, text, relatedStories, cta }) {
  const { items } = useRelatedStories(relatedStories);

  return (
    <PagepartBase id={id}>
      <Carousel
        title={title}
        text={text}
        items={items}
        cta={cta}
        SlideItem={StoryItem}
      />
    </PagepartBase>
  );
}

RelatedStoriesSection.propTypes = relatedStoriesType;

export default RelatedStoriesSection;
